__turbopack_context__.v({
  "active": "PublicProfilePortrait-module__juZvnW__active",
  "back": "PublicProfilePortrait-module__juZvnW__back",
  "backOne": "PublicProfilePortrait-module__juZvnW__backOne",
  "backTwo": "PublicProfilePortrait-module__juZvnW__backTwo",
  "caption": "PublicProfilePortrait-module__juZvnW__caption",
  "connection": "PublicProfilePortrait-module__juZvnW__connection",
  "constellation": "PublicProfilePortrait-module__juZvnW__constellation",
  "front": "PublicProfilePortrait-module__juZvnW__front",
  "photo": "PublicProfilePortrait-module__juZvnW__photo",
  "scene": "PublicProfilePortrait-module__juZvnW__scene",
  "selected": "PublicProfilePortrait-module__juZvnW__selected",
  "stack": "PublicProfilePortrait-module__juZvnW__stack",
  "topic": "PublicProfilePortrait-module__juZvnW__topic",
  "topicList": "PublicProfilePortrait-module__juZvnW__topicList",
});
